import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Building2, ArrowLeft } from 'lucide-react';
import { useIsNativeApp } from '../hooks/useIsNativeApp';


const PublicLayout = ({ children }) => {
  const navigate = useNavigate();
  const isNativeApp = useIsNativeApp();

  return (
    <div className="min-h-screen bg-stone-50">
    {!isNativeApp && (
      <header className="bg-white border-b border-stone-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Building2 className="text-[#1A4D2E]" size={24} />
            <span className="text-lg font-bold text-[#1A4D2E]" style={{ fontFamily: '"Playfair Display", serif' }}>
              Real Estate Lead & Referral Network
            </span>
          </button>
          <div className="flex items-center gap-3">
            <Button onClick={() => navigate('/')} variant="ghost" size="sm" className="text-stone-600">
              <ArrowLeft size={16} className="mr-1" /> Home
            </Button>
            <Button onClick={() => navigate('/login')} variant="outline" size="sm" className="text-[#1A4D2E] border-[#1A4D2E]">
              Log In
            </Button>
          </div>
        </div>
      </header>
  )}
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-10">
        {children}
      </main>
    </div>
  );
};

export default PublicLayout;
